import React from "react";

const CurrentPageContext = React.createContext({});

export default CurrentPageContext;
